<div class="background-overlay"></div>
<div class="fullscreen-panel splash-subscribe-wrapper">
  <app-join-membership-screen
    [isMobile]="true"
    [isDisabled]="isSubscriptionInProcess"
    [mainBtnTitle]="mainBtnTitle"
    (mainBtnClicked)="onMainBtnClick()">
  </app-join-membership-screen>



</div>
